/* @flow */

import invariant from 'invariant';
import {
    type Brand,
    type Card,
    type MetodosPagamento,
    type ParametrosCredito,
} from './types';

type ErrorPagseguro = {
    error: boolean,
}

type ResponseBandeira = ErrorPagseguro & {
    brand: Brand,
};

type ResponseMetodosPagamento = ErrorPagseguro & {
    paymentMethods: MetodosPagamento,
};

type ResponseCardToken = ErrorPagseguro & {
    card: Card,
}

const pagseguro = {
    getBandeira(cardBin: string): Promise<Brand> {
        return new Promise((resolve, reject) => {
            invariant(global.PagSeguroDirectPayment, 'JavaScript do PagSeguro não foi carregado na página');
            global.PagSeguroDirectPayment.getBrand({
                cardBin,
                success(response: ResponseBandeira) {
                    if (response.error) {
                        reject(response);
                        return;
                    }
                    resolve(response.brand);
                },
                error: response => reject(response),
            });
        });
    },
    getMetodosPagamento(amount: number): Promise<MetodosPagamento> {
        return new Promise((resolve, reject) => {
            invariant(global.PagSeguroDirectPayment, 'JavaScript do PagSeguro não foi carregado na página');
            global.PagSeguroDirectPayment.getPaymentMethods({
                amount,
                success(response: ResponseMetodosPagamento) {
                    if (response.error) {
                        reject(response);
                        return;
                    }
                    resolve(response.paymentMethods);
                },
                error: response => reject(response),
            });
        });
    },
    getSenderHash(): string | null {
        if (!global.PagSeguroDirectPayment) {
            return null;
        }
        return global.PagSeguroDirectPayment.getSenderHash();
    },
    createCardToken(dados: ParametrosCredito): Promise<Card> {
        return new Promise((resolve, reject) => {
            global.PagSeguroDirectPayment.createCardToken({
                brand: `${dados.bandeira}`,
                cardNumber: dados.numeroCartao.replace(/\s/g, ''),
                cvv: dados.cvvCartao,
                expirationMonth: dados.mesCartao,
                expirationYear: dados.anoCartao,
                success(response: ResponseCardToken) {
                    if (response.error) {
                        reject(response);
                        return;
                    }
                    resolve(response.card);
                },
                error: response => reject(response),
            });
        });
    },
    setSessionId: (sessionId: string) => {
        invariant(global.PagSeguroDirectPayment, 'JavaScript do PagSeguro não foi carregado na página');
        global.PagSeguroDirectPayment.setSessionId(sessionId);
    },
};

export default pagseguro;
